import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

/**
 * Configuration object for PKCE (Proof Key for Code Exchange) authentication.
 * 
 * @constant
 * @type {AuthConfig}
 * 
 * @property {string} issuer - The URL of the authorization server's issuer identifier.
 * @property {string} redirectUri - The URI to which the authorization server will redirect the user after authentication.
 * @property {string} clientId - The client identifier as registered with the authorization server.
 * @property {string} responseType - The type of response desired from the authorization server (e.g., 'code').
 * @property {boolean} strictDiscoveryDocumentValidation - Flag indicating whether strict validation of the discovery document should be enforced.
 * @property {string} scope - A space-separated list of scopes that the application is requesting access to.
 * @property {boolean} showDebugInformation - Flag indicating whether to show debug information.
 */
export const authConfigPKCE: AuthConfig = {
  issuer:
    'https://adbihlerb2c.b2clogin.com/68bbf77d-1ca3-4a8f-85c0-c34013ace1f1/v2.0/',
  redirectUri: window.location.origin,
  clientId: environment.b2cClientId,
  responseType: 'code',
  strictDiscoveryDocumentValidation: false,
  scope: 'openid offline_access ' + environment.b2cScopeUrl,
  showDebugInformation: false
};
